<template>
    <b-overlay :show="showLoader">
        <b-card>
            <b-button variant="primary" @click="$router.push({name: 'add-news'})" v-if="$hasPermissions($permissions.EditNews)">Dodaj novico</b-button>
            <b-button class="ml-2" variant="primary" @click="ClearHighlightedNews()" v-if="$hasPermissions($permissions.EditNews)">Počisiti izpostavljeno novico</b-button>
            <b-alert class="mt-1 p-1 text-center" show variant="warning" v-if="hasBeenDeleted">Po brisanju je potrebnih nekaj sekund, da je brisanje izvedeno. Če je novica po brisanju še vedno vidna, ponovno naložite stran.</b-alert>
            <Table ref="table" class="mt-1" :fields="fields" route="/api/management/v1/es/news" :fromElastic="true">
                <template #cell(main_photo)="row">
                    <b-img fluid :src="`/api/management/v1/image/thumbnail_${row.item.main_photo}`" style="width: 100%; max-height: 70px; object-fit: contain;" alt="Image"/>
                </template>
                <template #cell(date_added)="row">
                    {{ moment(row.item.date_added).format('DD.MM.YYYY') }}
                </template>
                <template #cell(active)="row">
                    <b-badge v-if="row.item.active" variant="light-success">
                        Da
                    </b-badge>
                    <b-badge v-else variant="light-danger">
                        Ne
                    </b-badge>
                </template>
                <template #cell(actions)="row" v-if="$hasPermissions($permissions.EditNews)">
                    <div class="button-grid">
                        <!-- <b-button variant="primary" :href="'/novice/' + row.item.id" target="_blank"><fa icon="newspaper"/></b-button> -->
                        <b-button variant="warning" @click="$router.push({name: 'edit-news', params: {'news_id': row.item.id}})"><fa icon="edit"/></b-button>
                        <b-button variant="info" @click="highlightNews(row.item.id)"><fa icon="check-square"/></b-button>
                        <b-button @click="deleteNews(row.item.id)" variant="danger"><fa icon="trash"/></b-button>

                        <b-badge style="display: flex; justify-content: center; align-items: center;" v-if="highlighted !== null && row.item.id === highlighted.id" variant="light-success">
                            Prikazna
                        </b-badge>
                        
                    </div>
                </template>
            </Table>
        </b-card>
    </b-overlay>
</template>
<script>

    import Table from '@/views/Components/Table'
    import {BOverlay, BButton, BImg, BCard, BBadge, BAlert} from 'bootstrap-vue'
    export default {
        components: {
            Table,
            BOverlay,
            BButton,
            BImg,
            BCard,
            BBadge,
            BAlert
        },
        data() {
            return {
                showLoader: false,
                fields: [
                    { key: 'main_photo', label: 'Slika', sortable: true, class: 'text-center' },
                    { key: 'title', label: 'Naslov', sortable: true, class: 'text-center' },
                    { key: 'date_added', label: 'Datum', sortable: true, class: 'text-center', type: 'date' },
                    { key: 'active', label: 'Aktivno', sortable: true, class: 'text-center', type: 'bool' }
                ],
                hasBeenDeleted: false,
                highlighted: null
            }
        },
        methods: {
            deleteNews(id) {
                this.$bvModal.msgBoxConfirm('Prosimo potrdite, da želite izbrisati novico.', {
                    size: 'sm',
                    okTitle: 'Da',
                    cancelTitle: 'Ne',
                    hideHeaderClose: false,
                    okVariant: 'danger',
                    cancelVariant: 'outline-secondary',
                    centered: true
                }).then(value => {
                    if (value) {
                        const thisIns = this
                        thisIns.showLoader = true
                        this.$http.delete(`/api/management/v1/news/${id}`)
                            .then(() => {
                                thisIns.$printSuccess('Novica je izbrisana')
                                thisIns.hasBeenDeleted = true

                                setTimeout(() => {
                                    thisIns.hasBeenDeleted = false
                                }, 10_000)

                                setTimeout(() => {
                                    thisIns.$refs.table.search()
                                }, 1000)
                            }).catch((error) => {
                                thisIns.$printError(error.response.data)
                            }).finally(function() {
                                thisIns.showLoader = false
                            })
                    }
                })
            },
            async highlightNews(id) {
                try {
                    const payload = {
                        'news_id':id
                    }

                    await this.$http.post('/api/management/v1/news/', payload)
                    await this.GetHighlightNews()
                    this.$printSuccess('Novica je izpostavljena')
                } catch (error) {
                    this.$printError(error.response.data)
                } finally {
                    this.showLoader = false
                }

            },

            async ClearHighlightedNews() {
                try {
                    await this.$http.delete('/api/management/v1/news/highlight ')
                    await this.GetHighlightNews()
                    this.$printSuccess('Izpostavljena novica je počiščena')
                } catch (error) {
                    this.$printError(error.response.data)
                } finally {
                    this.showLoader = false
                }

            },

            async GetHighlightNews() {
                try {
                    const response = await this.$http.get('/api/management/v1/es/news/highlighted')
                    this.highlighted = response.data.items ?? null
                } catch (error) {
                    this.$printError(error.response.data)
                } finally {
                    this.showLoader = false
                }

            }
        },
        async mounted() {
            if (this.$hasPermissions(this.$permissions.EditNews)) {
                this.fields.push({ key: 'actions', label: '', class: 'text-center' })
            }
            await this.GetHighlightNews()
        }
    }
</script>
<style scoped>
.button-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    column-gap: 10px;
    row-gap: 10px;
}
</style>